import util from '../util'

let controller = 'QRCodePix'
export default Object.assign({}, {
    CriarEstatico: function (dto) {
        return util.Axios.Post(controller + '/CriarEstatico', dto)
    },
    CriarDinamico: function (dto) {
        return util.Axios.Post(controller + '/CriarDinamico', dto)
    },
    CriarCobranca: function (dto) {
        return util.Axios.Post(controller + '/CriarCobranca', dto)
    },
    Ler: function (dto) {
    return util.Axios.GetAll(`${controller}/Ler`,dto,true)
    },
    BuscarQRCode: function (id) {
        return util.Axios.Get(controller + '/BuscarQRCodePixCobranca',id)
    },
    Listar: function (dto, options) {
        if (options && options.data) dto.data = options.data
        return util.Axios.GetAll(controller + '/Listar',dto)
    },
    CancelarQRCode: function (codigoQrCode) {
        return util.Axios.Post(`${controller}/${codigoQrCode}/CancelarQRCode`)
    }
})